import React, { useEffect, useState, useContext } from 'react';
import { Container, Button, Message, Icon, Card } from 'semantic-ui-react'
import { MdDoNotDisturbOff } from 'react-icons/md';
import { ConnectWS } from '../../../../ConnectWS';
import AuthContext from '../../../../context/authContext';
import CountDownTimer from '../../countDownTimer/CountDownTimer';
import { bruttoToNetto, checkDateStartBeforeNow, checkiscompanypay } from '../../../../myfunctions';
import moment from 'moment';
import BuyProductCompany from './BuyProductCompany';

function BuySupport(props) {
  const [form, setForm] = useState(null);
  const [message, setMessage] = useState(null);
  const authContext = useContext(AuthContext);
  const [tournament_id, settournament_id] = useState(0);
  const [startTournament, setstartTournament] = useState(null);

  const valAmount = 246.00

  function generateHotPayDataTournamentSupport() {
    ConnectWS("/payment/generateHotPayDataTournamentSupport", authContext.token, { tournament_id: tournament_id, amount: valAmount }, function (response, logout) {

      if (logout === 1) {
        setMessage(response.data)
        setForm(null)
      } else if (response && response.status && Number(response.status) === 200) {
        //setRowDataTournament(response.data)
        setForm(response.data)
        document.getElementById("orderHPTS").submit();
        setMessage(null)
      } else {
        console.log(response);
        setForm(null)
        setMessage(response)
      }

    });
  }


  function getDateMinusDay(dt) {
    try {
      return moment(dt).subtract(1, 'days').format('YYYY-MM-DD HH:mm:ss');
    } catch {
      return dt
    }
  }

  useEffect(() => {
    if (props.propsParamsT) {
      setstartTournament(props.propsParamsT.startTournament)
      settournament_id(props.propsParamsT.tournament_id)
    }
    return () => { }; // use effect cleanup to set flag false, if unmounted
  }, [startTournament])// eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container textAlign='center'>
      {startTournament ?
        <CountDownTimer endDate={getDateMinusDay(startTournament)} textValue="Możesz jeszcze wykupić wsparcie techniczne dla tego turnieju przez:" textValueFinish="Wsparcie dla tego turnieju jest zamknięte." beautifulText="1" />
        : ""}
      <p style={{ margin: 10 }}>
        Zapewnij sobie spokój przed turniejem!
        Wsparcie techniczne dostępne do wykupienia <b>maksymalnie dzień przed startem eventu</b>,
        abyśmy mogli perfekcyjnie się przygotować.<br /> Koszt wsparcia wynosi <br /><b>{bruttoToNetto(valAmount)} PLN NETTO</b> <br /><b>{valAmount} PLN BRUTTO</b> <br />za dostęp do naszych specjalistów, podczas trwania turnieju<br />
        Inwestuj w spokój ducha i gwarancję bezproblemowego przebiegu Twojego turnieju!
      </p>
      {checkDateStartBeforeNow(getDateMinusDay(startTournament)) ?
        <Card.Group centered>

          <Card className='colorSegmentCardDarkSukcesy0' link color='blue' >
            <Card.Content className='ContentCenter'>
              <span style={{ fontSize: 35, margin: 0, padding: 0, marginLeft: -15 }} className='ContentCenterIcon1AD'>
                <Icon.Group >
                  <Icon size='big' name='handshake' />

                </Icon.Group>
              </span>
              <Card.Header>WSPARCIE TECHNICZNE</Card.Header>
              <Card.Meta style={{ fontSize: 12 }}><Icon name="credit card" /> PŁATNOŚĆ BLIK LUB ONLINE</Card.Meta>
              <Card.Meta style={{ fontSize: 12 }}><MdDoNotDisturbOff /> BEZ REJESTRACJI</Card.Meta>
            </Card.Content>
            <Card.Content extra>
              {checkiscompanypay() ?
                <BuyProductCompany payable_service_id={null} buyProductType={3} tournament_id={tournament_id} messageProduct={"Wsparcie techniczne"} isToken={false} isDemo={false} issmall={false} btnname={"ZAMAWIAM"} price={valAmount} />
                :
                <Button basic color='blue' onClick={() => generateHotPayDataTournamentSupport()}>
                  <b>ZAMAWIAM</b>
                </Button>
              }
            </Card.Content>
          </Card>

        </Card.Group>
        : ""}

      <br />

      {message ? <Message negative>
        <Message.Header>ERROR</Message.Header>
        <p>{message}</p>
      </Message> : ""}

      {form ?
        <form style={{ display: "none" }}
          id="orderHPTS"
          action="https://platnosc.hotpay.pl/"
          method="post">
          <input required name="SEKRET" value={form.SEKRET} type="hidden" />
          <input required name="HASH" value={form.HASH} type="hidden" />
          <input required name="KWOTA" value={form.KWOTA} type="hidden" />
          <input required name="NAZWA_USLUGI" value={form.NAZWA_USLUGI} type="hidden" />
          <input required name="ADRES_WWW" value={form.ADRES_WWW} type="hidden" />
          <input required name="ID_ZAMOWIENIA" value={form.ID_ZAMOWIENIA} type="hidden" />
          <input name="EMAIL" value={form.EMAIL} type="hidden" />
          <input name="DANE_OSOBOWE" value={form.DANE_OSOBOWE} type="hidden" />
          <button type="submit">Submit</button>
        </form>
        : ""}
    </Container>

  )
}

export default BuySupport;